import { $Q, $Qll } from '../utils/query-selector'

/**
 * Send form with language selected
 * @author Daniel Santos
 */
export function laguangesComponent(form) {
  const localizationForm = $Q(form)
  const input = $Q('input[name="language_code"], input[name="country_code"]', localizationForm)
  const countries = $Qll('a.markets-js', localizationForm)

  countries.forEach((item) => {
    item.addEventListener('click', (e) => {
      e.preventDefault();
      const form = $Q('form', localizationForm);

      input.value = e.currentTarget.dataset.value;

      if (form) form.submit();
    })
  })
}
